import { MouseEventHandler, ReactNode } from 'react';

import {
  menu,
  menuItem,
  menuItemContentMain,
  menuItemContentPrefix,
  menuItemContentSurfix,
} from './styles.css';

export interface MenuProps {
  children: ReactNode;
}

export const Menu = (props: MenuProps) => {
  const { children } = props;
  return <ul className={menu}>{children}</ul>;
};

export interface MenuItemProps {
  children: ReactNode;
  /**
   * 왼쪽 끝에 위치하는 요소입니다.
   */
  prefix?: ReactNode;
  /**
   * 오른쪽 끝에 위치하는 요소입니다.
   */
  surfix?: ReactNode;
  /**
   * 선택됨 효과를 적용할 수 있습니다.
   */
  selected?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
  /**
   * 항목을 비활성화합니다.
   */
  disabled?: boolean;
}

Menu.Item = (props: MenuItemProps) => {
  const { children, prefix, surfix, selected, onClick, disabled } = props;

  return (
    <li>
      <div
        className={menuItem({
          clickable: !!onClick,
          selected,
          disabled,
        })}
        onClick={disabled ? undefined : onClick}
      >
        {prefix && <div className={menuItemContentPrefix}>{prefix}</div>}
        <div className={menuItemContentMain}>{children}</div>
        {surfix && <div className={menuItemContentSurfix}>{surfix}</div>}
      </div>
    </li>
  );
};
